(function () {
  var config = window.themeTaxDisplay || {};
  var storageKey = 'taxDisplayMode';
  var enabled = !!config.enabled;
  var defaultMode = config.defaultMode === 'ex' ? 'ex' : 'inc';
  var currentMode = document.documentElement.getAttribute('data-tax-mode') || defaultMode;

  function persist(mode) {
    if (!enabled) return;
    try {
      localStorage.setItem(storageKey, mode);
    } catch (error) {
      console.warn('Unable to persist tax display mode', error);
    }
  }

  function setMode(nextMode, options) {
    if (nextMode !== 'inc' && nextMode !== 'ex') return;
    if (currentMode === nextMode) {
      updateUI();
      return;
    }
    currentMode = nextMode;
    document.documentElement.setAttribute('data-tax-mode', currentMode);
    if (!options || !options.skipStorage) {
      persist(currentMode);
    }
    updateUI();
    document.dispatchEvent(new CustomEvent('taxDisplay:change', { detail: { mode: currentMode } }));
  }

  function updateUI() {
    var toggles = document.querySelectorAll('[data-tax-toggle]');
    if (!toggles.length) return;

    var message = currentMode === 'inc' ? 'Showing prices inc. GST' : 'Showing prices ex. GST';

    toggles.forEach(function (toggle) {
      var buttons = toggle.querySelectorAll('[data-tax-option]');
      buttons.forEach(function (button) {
        var value = button.getAttribute('data-tax-option');
        button.setAttribute('aria-pressed', value === currentMode ? 'true' : 'false');
      });

      var state = toggle.querySelector('[data-tax-state]');
      if (state) {
        state.textContent = message;
      }
    });
  }

  function handleClick(event) {
    var button = event.target.closest('[data-tax-option]');
    if (!button) return;
    if (!button.closest('[data-tax-toggle]')) return;
    var value = button.getAttribute('data-tax-option');
    setMode(value);
  }

  function observeDom() {
    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      var shouldUpdate = mutations.some(function (mutation) {
        if (!mutation.addedNodes || !mutation.addedNodes.length) return false;
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return false;
          if (node.hasAttribute && node.hasAttribute('data-tax-toggle')) return true;
          if (node.querySelector && (node.querySelector('[data-tax-toggle]') || node.querySelector('.price__amount'))) return true;
          return false;
        });
      });
      if (shouldUpdate) {
        requestAnimationFrame(updateUI);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateUI();
    document.addEventListener('click', handleClick);
    observeDom();
  });

  document.addEventListener('shopify:section:load', updateUI);
  document.addEventListener('shopify:section:reorder', updateUI);

  window.themeTaxDisplay = Object.assign({}, config, {
    setMode: setMode,
    mode: currentMode
  });
})();
